import { Filter, ReferenceInput, SelectInput, TextInput, List, RadioButtonGroupInput } from 'react-admin';
import React from 'react';

export const PlacementFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Email" source="email._ilike" alwaysOn parse={value => {
            if(value === "" || value === "%%" || value === "%"){
                return "";
            }else {
                const val = value.split("%")
                    .join("");
                return `%${val}%`
            }

        }} />
    </Filter>
);
